import { Pipe, PipeTransform } from '@angular/core';
import {KulturNavFolder} from '../../core/definitions/kultur-nav/kultur-nav-folder';

@Pipe({
    name: 'KulturNavFolderFilter',
    standalone: false
})
export class KulturNavFolderFilterPipe implements PipeTransform {

  /**
   * Filter KulturNavFolder by entity_name
   * @param dataSource list of KulturNavFolder
   * @param search query string
   */
  transform(dataSource: KulturNavFolder[], search: string): unknown {
    if (!search) {
      return dataSource;
    } else {
      return dataSource.filter(data => data.name.name.trim().toLowerCase().includes(search.trim().toLowerCase()));
    }
  }

}
